export function StickyHero() {
  return (
    <section className="relative h-[60vh] md:h-[80vh] w-full">
      <img
        src="/assets/bg1.jpg"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40" />
    </section>
  )
}